import { IIconProps, MessageBar, MessageBarType } from '@fluentui/react';
import * as React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { PropsWithChildren } from '../../types/props-with-children';
import { MessageBannerActionProps, MessageBannerActions } from './message-banner-actions';

type MessageBannerProps = PropsWithChildren<{
    iconProps?: IIconProps;
    onDismiss?: () => void;
    onSeeDetails?: () => void;
    messageBarType?: MessageBarType;
    additionalActions?: MessageBannerActionProps[];
}>;

const messages = defineMessages({
    messageBarCloseButton: {
        id: 'ResourceCard_MessageBar_CloseButton',
        defaultMessage: 'Close Message Bar',
        description: 'Aria label for the close button in the message bar.',
    },
});

export const MessageBanner: React.FC<MessageBannerProps> = (props: MessageBannerProps) => {
    const { children, iconProps, onDismiss, onSeeDetails, messageBarType, additionalActions } = props;

    // Intl hooks
    const { formatMessage } = useIntl();

    const messageBannerActions = React.useMemo(() => {
        return <MessageBannerActions onSeeDetails={onSeeDetails} additionalActions={additionalActions} />;
    }, [onSeeDetails]);

    return (
        <MessageBar
            actions={messageBannerActions}
            delayedRender={false}
            messageBarIconProps={iconProps}
            messageBarType={messageBarType}
            onDismiss={onDismiss}
            dismissButtonAriaLabel={formatMessage(messages.messageBarCloseButton)}
        >
            {children}
        </MessageBar>
    );
};

export default MessageBanner;
